import styled from "styled-components";

export const ContentWrapper = styled.div`
  position: absolute;
  width: 390px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background: white;
  top: 0;
  margin: auto;
  right: 0;
  padding: 17px 16px 0 25px;
`;

export const FullScreenContentWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background: white;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
`;

export const CloseButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: 5px;
`;

export const FullScreenCloseButtonWrapper = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 10;
`;
